var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v(_vm._s(this.rows.length)+" teams have registered.")]),_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"pagination-options":{ enabled: true },"sort-options":{ enabled: true }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }